
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compact-images",
      function () {
        return require("private-next-pages/compact-images/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compact-images"])
      });
    }
  